import classNames from 'classnames';
import { FragmentType, getFragmentData, graphql } from 'client/gql';
import { BpCard } from 'components/BpCard/BpCard';
import { useState } from 'react';
import { findClosestEventToNow } from 'utils/dateCalculations';
import styles from './DashboardEvents.module.scss';
import { getDashboardEvents } from './getDashboardEvents';
import { BpCalendar } from 'components/BpCalendar/BpCalendar';
import { EventsList } from 'components/EventsList/EventsList';

const DashboardEventsFieldsDocument = graphql(`
  fragment DashboardEventsFields on Query {
    ...EventsListFields
    ...DashboardEventsQueryFields
  }
`);

// Type for the event click handler
type EventClickHandler = (uuid: string) => void;

type DashboardEventsProps = {
  query: FragmentType<typeof DashboardEventsFieldsDocument> | undefined;
  isOrganizationAdmin: boolean;
  profileUuid: string;
  onAdd?: (edit: boolean) => void;
};

export function DashboardEvents({ isOrganizationAdmin, onAdd, query }: DashboardEventsProps) {
  const fragment = getFragmentData(DashboardEventsFieldsDocument, query);
  const dashboardEvents = getDashboardEvents(fragment);
  const closestEvent = findClosestEventToNow(dashboardEvents);
  const [scrollUuid, setScrollUuid] = useState<string | null>(closestEvent ? closestEvent.uuid : null);
  const [randomRedrawString, setRandomRedrawString] = useState<string>('');
  const handleEventClick: EventClickHandler = (uuid: string): void => {
    setRandomRedrawString(Date.now().toString());
    setScrollUuid(uuid);
  };

  return (
    <div className={classNames(styles.tab, styles['calendar-tab'])}>
      <BpCard className={styles.calendar} noPadding showBorder hideBackground>
        <BpCalendar
          events={dashboardEvents}
          showAddButton={isOrganizationAdmin}
          onAdd={onAdd}
          isOnWhite
          eventClick={handleEventClick}
        />
      </BpCard>
      <EventsList
        query={fragment}
        className={styles.events}
        isOnWhite
        showCompactEvents
        events={dashboardEvents}
        scrollToUuid={scrollUuid}
        randomRedrawString={randomRedrawString}
      />
    </div>
  );
}
